import React from "react";
import { SummaryType } from "@ls/grouping-service";
import { titleCase } from "@ls/js-utils";
import { useDispatch, useSelector } from "react-redux";
import { DELETE_DEFINITION } from "./actions";
import {
  selectDefinitions,
  selectFetchingBookAnalyticsData,
} from "./selectors";
import CalcType from "state/Constants/CalcType";
import SelectionState from "state/selections/SelectionState";

import ScaleType from "state/Constants/ScaleType";

export const useColumnDefs = () => {
  const definitions = useSelector(selectDefinitions(SelectionState.COMMITTED));
  const fetchingBookAbsData = useSelector(
    selectFetchingBookAnalyticsData(SummaryType.ABSOLUTE),
  );
  const fetchingBookRelData = useSelector(
    selectFetchingBookAnalyticsData(SummaryType.RELATIVE),
  );

  const dispatch = useDispatch();
  return React.useMemo(() => {
    return definitions.reduce((columnDefs, bookAnalyticDefinition) => {
      const { bookAnalytic, basis, calcType, key, scaleType } =
        bookAnalyticDefinition;
      const columnDef = {
        field: key,
        colId: key,
        X_onDelete: () =>
          dispatch({
            type: DELETE_DEFINITION,
            payload: bookAnalyticDefinition,
          }),
      };
      const scalePrefix = scaleType === ScaleType.Contribution ? "C-" : "";
      switch (calcType) {
        case CalcType.Account:
          columnDef.headerName = `Acct ${scalePrefix}${titleCase(bookAnalytic)} ${titleCase(basis)}`;
          columnDef.loading = fetchingBookAbsData;
          break;
        case CalcType.Relative:
          columnDef.headerName = `Rel ${scalePrefix}${titleCase(bookAnalytic)} ${titleCase(basis)}`;
          columnDef.loading = fetchingBookRelData;
          break;
        case CalcType.Benchmark:
          columnDef.headerName = `Bench ${scalePrefix}${titleCase(bookAnalytic)} ${titleCase(basis)}`;
          columnDef.loading = fetchingBookAbsData;
          break;
        default:
          throw Error("Unknown calc type: " + calcType);
      }
      columnDefs.push(columnDef);

      return columnDefs;
    }, []);
  }, [dispatch, definitions, fetchingBookAbsData, fetchingBookRelData]);
};
